module.exports = __webpack_public_path__ + "img/ud_all_data.f9d8aabd.svg";